// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3OgdR","inputWrap":"Table_inputWrap__2CECi","col":"Table_col__J7jkQ","bmiTooltip":"Table_bmiTooltip__3KNZL"};